import React, {useEffect, useState} from 'react';
import PlacesAutocomplete, {geocodeByAddress} from 'react-places-autocomplete';
import * as PropTypes from 'prop-types';
import {PlacesAutocompleteFragment, OptionFragment} from './GoogleAutofillForm.styled';
import '../../../../../../assets/svgs/search.svg';
import {StyledFloatLabel} from '../../../shared/Form/Form.styled';
import I18n from 'i18n-js';

const GoogleAutofillForm = ({setResults, indexAddress = ''}) => {
  const [placesService, setPlacesService] = useState(null);
  const [address, setAddress] = useState(indexAddress);
  const [isIndex, setIsIndex] = useState(true);

  useEffect(() => {
    // if window.google is defined, set the PlacesService
    if (typeof window.google !== 'undefined') {

      setPlacesService(new window.google.maps.places.PlacesService(document.createElement('div')));
    } else {
      // if window.google is not defined, wait .5s and try again
      setTimeout(() => {
        if(window.google.maps) {
          setPlacesService(new window.google.maps.places.PlacesService(document.createElement('div')) || null);
        }
      }, 500)
    }
  }, []);

  const handleSelect = async val => {
    setAddress(val);
    const results = await geocodeByAddress(val);
    const convertedAddress = addressConvert(results[0].address_components);
    placesService.getDetails({placeId: results[0].place_id},
      result => {
        if (result.types.includes('establishment')) {
          convertedAddress['beverage_retailer_name'] = result.name
        }
        setResults(convertedAddress);
      });
  };


  const addressConvert = address => {
    return address.reduce((node, {long_name, short_name, types}) => {
      //Convert google places api response toto object that can correspond form fields.
      types.forEach(t => {
        switch (t) {
          case 'locality':
          case 'postal_town':
            node['city'] = long_name;
            break;
          case 'route':
          case 'street_number': {
            node['address_line_1'] = `${node['address_line_1'] || ''} ${long_name}`;
          }
            break;
          case 'administrative_area_level_1':
            node['stateAddress'] = short_name;
            node['regionAddress'] = short_name;
            if (!node['city'])
              node['city'] = long_name;
            break;
          case 'country':
            node['country'] = long_name;
            node['countryCode'] = short_name;
            break;
          default:
            node[t] = long_name;
        }
      });
      return node;
    }, {})
  };

  return (
    placesService &&
    <PlacesAutocompleteFragment>
      <PlacesAutocomplete
        onChange={e => {
          if (isIndex) {
            e = indexAddress ? `${indexAddress} ${e}` : e;
            setIsIndex(false);
          }
          setAddress(e)
        }} onSelect={handleSelect} value={address}>
        {({getInputProps, suggestions, getSuggestionItemProps}) => (
          <div style={{position: 'relative'}}>
            <input id='google' {...getInputProps()} />
            {suggestions.map(suggestion => {
              return (
                <OptionFragment {...getSuggestionItemProps(suggestion)}>
                  {suggestion.description}
                </OptionFragment>
              )
            })}
            <StyledFloatLabel hasvalue={address ? 'true' : ''} htmlFor='google' >
              {I18n.t('retailerForm.establishmentHelperMessage')}
            </StyledFloatLabel>
          </div>
        )}
      </PlacesAutocomplete>
    </PlacesAutocompleteFragment>
  )
};

GoogleAutofillForm.propTypes = {
  indexAddress: PropTypes.string,
  setResults: PropTypes.func
};

export default GoogleAutofillForm;
